import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { useMemo, useRef, useEffect } from 'react';
import { cx, isFunction } from '@elliemae/ds-utilities/utils';
import { VariableSizeList } from 'react-window';
import ArrowheadDown from '@elliemae/ds-icons/ArrowheadDown';
import ArrowheadRight from '@elliemae/ds-icons/ArrowheadRight';
import DSButton from '@elliemae/ds-basic/Button';
import createInstancePlugin from '@elliemae/ds-shared/createDataInstance/createInstancePlugin';
import { appendCellFormatter } from '@elliemae/ds-shared/useDataGrid/initColumnDefinition';
import ExpandedRow from './ExpandedRow.js';
import ExpandedRowExtra from './ExpandedRowExtra.js';
import { RowSizes } from '../../rowSizes.js';
import { useExpandGridState } from './useExpandGridState.js';
import '@elliemae/ds-basic/Separator';
import 'styled-components';
import '@elliemae/ds-shared/defer-render-hoc';
import '@elliemae/ds-shared/useDataGrid';
import '../pagination/PaginationPlugin.js';
import '@babel/runtime/helpers/esm/extends';
import '@elliemae/ds-utilities/system';
import '@elliemae/ds-shared/FocusGroup/FocusGrid';
import '../pagination/helper.js';
import '../pagination/usePaginationState.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@elliemae/ds-utilities/hooks/useDerivedStateFromProps';
import '../../components/NoResults.js';
import '@elliemae/ds-system';
import '../../components/BodyCell.js';
import 'prop-types';
import '@elliemae/ds-shared/createDataInstance/utils';
import '@elliemae/ds-basic/TruncatedTooltipText';
import '../../index-4a6329dc.js';
import '../../components/renderers/defaultClassedRenderers.js';
import '@elliemae/ds-classnames';
import '../../blockNames.js';
import '../../components/renderers/renderRowsLoader.js';
import '../../components/RowsLoader.js';
import '@elliemae/ds-basic/Spinner';
import '../../components/TableBody.js';
import '../../components/tableContext.js';
import '../../components/Table.js';
import '../../components/TableHeader.js';
import '../../components/HeaderCell.js';
import '../column-sizing/ColumnSizingPlugin.js';
import '../column-sizing/useStylesheetHelpers.js';
import 'stylesheet-helpers';
import '../column-sizing/getColumnNameFromProperty.js';
import '../../utilities/getScrollbarSize.js';
import '../column-sizing/useColumnSizeService.js';
import '../column-sizing/utils.js';
import '../column-sizing/ext-points/getTableProps.js';
import '@elliemae/ds-utilities/hooks/useResizeObserver';
import '../column-sizing/ext-points/decorateColumn.js';
import '../column-sizing/columnMeasurerTransformer.js';
import '@elliemae/ds-utilities/hooks/useExpandState';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getExpandedRowSizeBySubrows = function getExpandedRowSizeBySubrows(_ref) {
  var totalAmount = _ref.totalAmount,
      amountVisible = _ref.amountVisible,
      isShowingAll = _ref.isShowingAll,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 36 : _ref$size;
  return isShowingAll ? size * (totalAmount + 1) - 6 : size * (amountVisible + 1) + 32;
};

var ExpandedRows = {
  SingleColumn: ExpandedRow,
  Master: ExpandedRowExtra
};

var createExpandedRow = function createExpandedRow(type) {
  return ExpandedRows[type] || ExpandedRows.Master;
};

var isExpandableSingleColumn = function isExpandableSingleColumn(columns) {
  return columns.some(function (column) {
    return column.expandableColumn;
  });
};

var ExpandablePlugin = createInstancePlugin('expandable', {
  registerStateHook: useExpandGridState,
  decorateGrid: function decorateGrid(grid) {
    var _grid$getInstance = grid.getInstance(),
        decoratedColumns = _grid$getInstance.decoratedColumns,
        columns = _grid$getInstance.columns;

    var detailColumns = useMemo(function () {
      return decoratedColumns.map(function (column) {
        return _objectSpread(_objectSpread({}, column), {}, {
          customRenderer: column.detailCustomRenderer
        });
      }).filter(function (col) {
        return !col.expandableColumn;
      });
    }, [columns]);
    return {
      detailColumns: detailColumns
    };
  },
  decorateColumns: function decorateColumns(columns, grid) {
    if (isExpandableSingleColumn(columns)) return columns; // get first column from user

    var firstColumnIndex = columns.findIndex(function (column) {
      return column.isUserColumn;
    });
    var firstColumn = columns[firstColumnIndex];
    firstColumn.formatExpandable = true;
    return [].concat(_toConsumableArray(columns.slice(0, firstColumnIndex)), [appendCellFormatter(function (value, _ref2) {
      var isExpanded = _ref2.isExpanded,
          rowData = _ref2.rowData;

      var _grid$getInstance2 = grid.getInstance(),
          toggleExpand = _grid$getInstance2.actions.toggleExpand;
      /*
       * should return only 2 elements ../custom-cell-renderer/addCustomRendererToCell.js
       * getRenderer it's checking that length to apply the custom render to value only
       */


      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DSButton, {
        buttonType: "text",
        className: "expandable-arrow",
        icon: isExpanded ? /*#__PURE__*/React.createElement(ArrowheadDown, null) : /*#__PURE__*/React.createElement(ArrowheadRight, null),
        onClick: function onClick(e) {
          e.stopPropagation();
          toggleExpand(rowData);
        },
        size: "s"
      }), value);
    }, firstColumn)], _toConsumableArray(columns.slice(firstColumnIndex + 1)));
  },
  getBodyProps: function getBodyProps(bodyProps, grid) {
    var _grid$getInstance3 = grid.getInstance(),
        rows = _grid$getInstance3.composedRows,
        _grid$getInstance3$pr = _grid$getInstance3.props,
        rowKey = _grid$getInstance3$pr.rowKey,
        getChildrenRows = _grid$getInstance3$pr.getChildrenRows,
        _grid$getInstance3$pr2 = _grid$getInstance3$pr.rowSize,
        rowSize = _grid$getInstance3$pr2 === void 0 ? 'normal' : _grid$getInstance3$pr2,
        _grid$getInstance3$pr3 = _grid$getInstance3$pr.subrowSize,
        subrowSize = _grid$getInstance3$pr3 === void 0 ? 'normal' : _grid$getInstance3$pr3,
        getExpandedRowMinSize = _grid$getInstance3$pr.getExpandedRowMinSize,
        getExpandedRowSize = _grid$getInstance3$pr.getExpandedRowSize,
        expandableSubrowsVisible = _grid$getInstance3$pr.expandableSubrowsVisible,
        expandedRows = _grid$getInstance3.state.expandedRows;

    var rowSizePx = RowSizes[rowSize];
    var subrowSizePx = RowSizes[subrowSize];
    var listRef = useRef();
    useEffect(function () {
      if (listRef.current) listRef.current.resetAfterIndex(0, true);
    }); // implementation of expandable row single column with aggregation

    var getItemSize = function getItemSize(index) {
      var rowData = rows[index];
      var key = rowData[rowKey];
      var children = getChildrenRows({
        rowData: rowData
      });
      var expandedSize = getExpandedRowSize ? getExpandedRowSize(index, {
        rowData: rowData
      }) // https://jira.elliemae.io/browse/PUI-1659
      : getExpandedRowSizeBySubrows({
        totalAmount: children.length,
        amountVisible: children.length > expandableSubrowsVisible ? expandableSubrowsVisible : children.length,
        isShowingAll: children.length < expandableSubrowsVisible || expandedRows[key] && expandedRows[key].showAllRows,
        size: subrowSizePx
      });
      var expandedMinSize = isFunction(getExpandedRowMinSize) && getExpandedRowMinSize(index); // eslint-disable-next-line no-nested-ternary

      return expandedRows[key] ? expandedMinSize > expandedSize ? expandedMinSize : expandedSize : rowSizePx;
    };

    return _objectSpread(_objectSpread({}, bodyProps), {}, {
      className: cx(bodyProps.className, 'expandable'),
      listComponent: VariableSizeList,
      listProps: {
        ref: listRef,
        itemSize: getItemSize
      }
    });
  },
  decorateRenderers: function decorateRenderers(renderers, grid) {
    var Row = renderers.body.row;
    var Cell = renderers.body.cell; // eslint-disable-next-line react/display-name

    renderers.body.row = useMemo(function () {
      // todo: the expandable grid should be created from another specific grid component
      var expandedRowType = isExpandableSingleColumn(grid.decoratedColumns) ? 'SingleColumn' : 'Master';
      var ExpandedRowComponent = createExpandedRow(expandedRowType); // eslint-disable-next-line react/display-name

      return function (_ref3) {
        var isExpanded = _ref3.isExpanded,
            rowProps = _objectWithoutProperties(_ref3, ["isExpanded"]);

        if (isExpanded) {
          var _grid$getInstance4 = grid.getInstance(),
              _grid$getInstance4$pr = _grid$getInstance4.props,
              detailColumns = _grid$getInstance4$pr.detailColumns,
              getChildrenRows = _grid$getInstance4$pr.getChildrenRows,
              renderRowDetails = _grid$getInstance4$pr.renderRowDetails,
              composedRows = _grid$getInstance4.composedRows; // https://jira.elliemae.io/browse/PUI-1667


          var rowData = composedRows[rowProps.index] ? composedRows[rowProps.index] : rowProps.rowData;
          return /*#__PURE__*/React.createElement(ExpandedRowComponent, {
            cellComponent: Cell,
            detailColumns: detailColumns,
            parentGrid: grid,
            renderRowDetails: renderRowDetails,
            rowComponent: Row,
            rowData: rowData,
            rowProps: _objectSpread({
              rowData: rowData,
              isExpanded: isExpanded
            }, rowProps),
            rows: getChildrenRows({
              rowData: rowData
            })
          }, rowProps.children);
        }

        return /*#__PURE__*/React.createElement(Row, rowProps);
      };
    }, []);
    return renderers;
  },
  getRowProps: function getRowProps(rowProps, grid, _ref4) {
    var rowData = _ref4.rowData;

    var _grid$getInstance5 = grid.getInstance(),
        rowKey = _grid$getInstance5.props.rowKey,
        expandedRows = _grid$getInstance5.state.expandedRows;

    var key = rowData[rowKey];
    var isExpanded = !!expandedRows[key];
    return _objectSpread(_objectSpread({}, rowProps), {}, {
      className: cx(rowProps.className, Object.keys(expandedRows).length > 0 && 'expandable-row', isExpanded && 'expanded'),
      isExpanded: isExpanded,
      showAllRows: expandedRows[key] && expandedRows[key].showAllRows
    });
  }
});

export { ExpandablePlugin };
//# sourceMappingURL=ExpandablePlugin.js.map
